import { downgradeComponent } from "@angular/upgrade/static";
import { GroupHierarchyComponent2 } from "@components/resourceManagement/groups/group-hierarchy/group-hierarchy.component";
import { VExportButtonComponent } from "@directives/_veri/export/v-export-button/v-export-button.component";
import { VCalendarComponent } from "@directives/_veri/v-calendar/v-calendar.component";
import { VDateSelectorComponent } from "@directives/_veri/v-date-selector/v-date-selector.component";
import { VListComponent } from "@directives/_veri/v-list/v-list.component";
import { VTimelineComponent } from "@directives/_veri/v-timeline/v-timeline.component";
import { VeriNavPillsComponent } from "@directives/_veri/veriPills/veriPills.component";
import { VeriRouteTabsComponent } from "@directives/_veri/veriTab/routeTabs.component";
import { CalendarComponent } from "@directives/calendar/veriCalendar.component";
import * as angular from "angular";
import { DashboardBoxSmallComponent } from "./dashboard/dashboardBoxSmall.component";
import { DownloadAsReportComponent } from "./downloadAsReport/downloadAsReport.component";
import { EventsExportComponent } from "./export/eventsExport/eventsExport.component";
import { JourneysExportComponent } from "./export/journeysExport/journeysExport.component";
import { LegacyExportService } from "./export/legacyExport.service";
import { PlotsExportComponent } from "./export/plotsExport/plotsExport.component";
import { ExternalReferenceComponent } from "./externalReference/externalReference.component";
import { ExternalReferenceService } from "./externalReference/externalReference.service";
import { ExternalReferenceRecordComponent } from "./externalReference/externalReferenceDialog/externalReferenceRecord.component";
import { GroupAutocompleteComponent } from "./group-autocomplete/group-autocomplete.component";
import { GroupSelectorComponent } from "./groupHierarchy/groupSelector.component";
import { TagsComponent } from "./tags/tags.component";
import { VDatePickerComponent } from "./v-date-picker/v-date-picker.component";
import { VDescriptiveListItemComponent } from "./v-descriptive-list-item/v-descriptive-list-item.component";
import { VPillsComponent } from "./v-pills/v-pills.component";
import { VTagsComponent } from "./v-tags/v-tags.component";
import { VTimeFiltersComponent } from "./v-time-filters/v-time-filters.component";
import { VeriBadgeComponent } from "./veriBadge/veriBadge.component";
import { VeriCardComponent } from "./veriCard/veriCard.component";
import { VeriColourPickerComponent } from "./veriColourPicker/veriColourPicker.component";
import { VeriDateRangeComponent } from "./veriDateRange/veriDateRange.component";
import { VeriInfoPanelComponent } from "./veriInfoPanel/veriInfoPanel.component";
import { VeriListComponent } from "./veriList/veriList.component";
import { VeriNumberFieldComponent } from "./veriNumberField/veriNumberField.component";
import { VeriPageComponent } from "./veriPage/veriPage.component";
import { VeriSearchBoxComponent } from "./veriSearchBox/veriSearchBox.directive";
import { VeriSimpleNavComponent } from "./veriSimpleNav/veriSimpleNav.component";
import { VeriTabComponent } from "./veriTab/veriTab.component";
import { VeriTabsComponent } from "./veriTab/veriTabs.component";
import { VeriTableComponent } from "./veriTable/veriTable.component";
import { VeriTableService } from "./veriTable/veriTable.service";
import { VeriTableContainerComponent } from "./veriTable/veriTableContainer/veriTableContainer.component";
import { VeriTableSummaryComponent } from "./veriTable/veriTableSummary/veriTableSummary.component";
import { VStreamCollectionComponent } from "./veriVideo/v-stream-collection/v-stream-collection.component";
import { VVideoCollectionComponent } from "./veriVideo/v-video-collection/v-video-collection.component";
import { VVideoComponent } from "./veriVideo/v-video.component";
import { VeriVideoComponent } from "./veriVideo/veriVideo.component";
import { VVideoControlsComponent } from "./veriVideo/videoControls/video-controls.component";
import { VVideoProgressComponent } from "./veriVideo/videoProgress/video-progress.component";
import { VeriVideoThumbnailsComponent } from "./veriVideoThumbnails/veriVideoThumbnails.component";

angular
    .module("app.veri.directives", ["app.map.directives"])
    .directive("dashboardBoxSmall", downgradeComponent({ component: DashboardBoxSmallComponent }))

    .service("externalReferenceService", ExternalReferenceService)
    .component("externalReferenceRecord", new ExternalReferenceRecordComponent())
    .component("externalReference", new ExternalReferenceComponent())

    .component("veriList", new VeriListComponent())
    .directive("veriColourPicker", downgradeComponent({ component: VeriColourPickerComponent }))
    .component("veriDateRange", new VeriDateRangeComponent())
    .directive("veriSearchBox", downgradeComponent({ component: VeriSearchBoxComponent }))
    .directive("veriSimpleNav", downgradeComponent({ component: VeriSimpleNavComponent }))
    .directive("veriBadge", downgradeComponent({ component: VeriBadgeComponent }))
    .directive("vTimeline", downgradeComponent({ component: VTimelineComponent }))
    .directive("vList", downgradeComponent({ component: VListComponent }))
    .directive("vPills", downgradeComponent({ component: VPillsComponent }))

    .directive("vTags", downgradeComponent({ component: VTagsComponent }))
    .component("tags", new TagsComponent())
    .directive("veriCard", downgradeComponent({ component: VeriCardComponent }))
    .directive("veriNavPills", downgradeComponent({ component: VeriNavPillsComponent }))
    .directive("veriInfoPanel", downgradeComponent({ component: VeriInfoPanelComponent }))
    .directive("vExportButton", downgradeComponent({ component: VExportButtonComponent }))
    .directive("veriNumberField", downgradeComponent({ component: VeriNumberFieldComponent }))

    .directive("vDatePicker", downgradeComponent({ component: VDatePickerComponent }))
    .directive("vCalendar", downgradeComponent({ component: VCalendarComponent }))
    .directive("vDateSelector", downgradeComponent({ component: VDateSelectorComponent }))
    .directive("vTimeFilters", downgradeComponent({ component: VTimeFiltersComponent }))

    .component("veriPage", new VeriPageComponent())
    .component("veriTab", new VeriTabComponent())
    .component("veriTabs", new VeriTabsComponent())
    .component("veriRouteTabs", new VeriRouteTabsComponent())
    .component("veriVerticalTabs", new VeriTabsComponent(true))

    .directive("veriTableContainer", downgradeComponent({ component: VeriTableContainerComponent }))
    .directive("veriTableSummary", downgradeComponent({ component: VeriTableSummaryComponent }))
    .component("veriTable", new VeriTableComponent())
    .component("downloadAsReport", new DownloadAsReportComponent())

    .component("veriVideo", new VeriVideoComponent())
    .directive("vVideo", downgradeComponent({component: VVideoComponent}))
    .directive("vVideoCollection", downgradeComponent({ component: VVideoCollectionComponent }))
    .directive("vStreamCollection", downgradeComponent({ component: VStreamCollectionComponent }))

    .directive("vVideoControls", downgradeComponent({ component: VVideoControlsComponent }))
    .directive("vVideoProgress", downgradeComponent({ component: VVideoProgressComponent }))

    .directive("veriVideoThumbnails", downgradeComponent({ component: VeriVideoThumbnailsComponent }))

    .directive("groupHierarchy2", downgradeComponent({ component: GroupHierarchyComponent2 }))
    .component("groupSelector", new GroupSelectorComponent())
    .component("groupAutocomplete", downgradeComponent({ component: GroupAutocompleteComponent }))

    .component("plotsExport", new PlotsExportComponent())
    .component("journeysExport", new JourneysExportComponent())
    .component("eventsExport", new EventsExportComponent())
    .service("exportService", LegacyExportService)

    .service("veriTableService", VeriTableService)

    .component("veriCalendar", new CalendarComponent())

    .directive("vDescriptiveListItem", downgradeComponent({ component: VDescriptiveListItemComponent }))
    ;
